App.OrderMiniPopupComponent = Em.Component.extend
  classNames: [ 'order-mini-popup' ]
  classNameBindings: [ 'isHidden:mini-popup-hidden' ]

  isActive: false
  isHidden: Em.computed.not('isActive')